// Phase-3 Slice 27 — Apply-gate predicate for the Rename preview dialog.
//
// Apply is only allowed when the plan is fully `ready` AND the planner could
// rewrite every dependent object. A non-empty `batch.unrewritable` means at
// least one dependent body (parse-failed / body-missing / no-emitter /
// unsupported-op — e.g. a stored proc, trigger, or SQLite constraint) would
// keep referencing the old name; enabling Apply in that state lets the user
// silently break those objects.
//
// #34 MUST-FIX 3: ambiguous (unqualified / 4-part linked-server) relation-ref
// rewrites are gated at the PLAN level — the planner excludes them from
// `objectEdits` unless the user opts in via the preview checkbox. So Apply is
// never blocked by their presence (they are surfaced + counted, not applied by
// default) and is never able to silently apply one: an ambiguous edit only
// reaches `objectEdits` after the explicit opt-in re-plan.

import type { PlanRenameResult } from './renamePlanner';

export function canApplyRename(
  status: string,
  result: PlanRenameResult | null | undefined,
): boolean {
  return (
    status === 'ready' &&
    result != null &&
    result.status === 'ok' &&
    result.batch.unrewritable.length === 0
  );
}
